import {
  Flex,
  Text,
  Center,
  Link,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import Image from "next/image";

import {
  Hedera,
  Polygon,
  Fantom,
  Terra_2_0,
  Binance,
} from "../assets/blockchains_dark";
import {
  Hedera_light,
  Binance_light,
  Polygon_light,
  Fantom_light,
  Terra_2_0_light,
} from "../assets/blockchains_light";
import Near_light from "../assets/blockchains_light/near_light.svg";
import Near from "../assets/blockchains_dark/near_dark.svg";
import chevron_right_light from "../assets/chevron_right_light.svg";
import chevron_right_dark from "../assets/chevron_right_dark.svg";
import { IIndexable } from "../constants";
import { getRefrenceParams as getReferenceParams } from "app-head";
import { useRouter } from "next/router";
import { useState, useEffect } from "react";

type StakignOptionsProps = {
  key: string;
  title: string;
  link: string;
};

type LiquidStakingProps = {
  stakingOptionsData: StakignOptionsProps[];
  trackLiquidStakingClick: (key: string) => void;
};

const BLOCKCHAINS_ICONS: IIndexable = {
  light: {
    hedera: Hedera_light,
    polygon: Polygon_light,
    near: Near_light,
    fantom: Fantom_light,
    terra: Terra_2_0_light,
    bnb: Binance_light,
  },
  dark: {
    hedera: Hedera,
    polygon: Polygon,
    near: Near,
    fantom: Fantom,
    terra: Terra_2_0,
    bnb: Binance,
  },
};

export const LiquidStaking = ({
  stakingOptionsData,
  trackLiquidStakingClick,
}: LiquidStakingProps) => {
  const { colorMode } = useColorMode();
  const router = useRouter();
  const [utmParams, setUTMParams] = useState<string>("");

  useEffect(() => {
    const { query } = router;
    const refParams = getReferenceParams();
    const x: any = {};

    for (let key in refParams) {
      if (query[key]) {
        x[key] = query[key];
      }
    }
    const search = new URLSearchParams(x).toString();
    setUTMParams(search === "" ? "" : `/?${search}`);
  }, [router]);

  const rightArrowIcon = useColorModeValue(
    chevron_right_light,
    chevron_right_dark
  );

  return (
    <>
      <Text
        fontWeight="600"
        fontSize="10px"
        lineHeight="16px"
        color="brand.social.text"
      >
        EXPLORE LIQUID STAKING
      </Text>
      {stakingOptionsData.map((chain) => (
        <Link
          cursor="pointer"
          href={`${chain.link}${utmParams}`}
          p="0 0.5rem"
          key={chain.key}
          h="24px"
          w="176px"
          mt="20px"
          isExternal={false}
          lineHeight="0px"
          onClick={() => trackLiquidStakingClick(chain.key)}
        >
          <Flex alignItems="center" justifyContent="space-between">
            <Flex alignItems="center">
              <Center
                h="24px"
                w="24px"
                borderRadius="50%"
                bg="brand.backgroundLight"
              >
                <Image
                  src={BLOCKCHAINS_ICONS[colorMode][chain.key]}
                  width={14}
                  height={14}
                  alt={chain.key}
                />
              </Center>
              <Text
                ml="0.5rem"
                fontWeight="500"
                fontSize="12px"
                color="brand.textColor"
                _hover={{
                  color: "brand.textInactive",
                }}
              >
                {chain.title}
              </Text>
            </Flex>
            <Image src={rightArrowIcon} width={24} height={24} alt="line" />
          </Flex>
        </Link>
      ))}
    </>
  );
};
